/**
 * Unit helpers — pass-through (no conversion).
 *
 * The DB now stores values in mm. Legacy rows that were in inches have
 * already been migrated or will be corrected manually. No automatic
 * conversion is performed on load or save.
 */

function trim(v: string | number | null | undefined): string {
  if (v == null) return '';
  return String(v).trim();
}

export function inchesToMm(v: string | number | null | undefined): string {
  return trim(v);
}

export function inchesToMmHeight(
  height: string | number | null | undefined,
  _length?: string | number | null | undefined,
  _width?: string | number | null | undefined,
): string {
  return trim(height);
}

export function mmToInches(v: string | number | null | undefined): string {
  return trim(v);
}

const SHEET_SIZE_RE = /^\s*(\d+(?:\.\d+)?)\s*[xX×]\s*(\d+(?:\.\d+)?)(.*)$/;

export function sheetSizeInchesToMm(v: string | null | undefined): string {
  return trim(v);
}
export function sheetSizeMmToInches(v: string | null | undefined): string {
  return trim(v);
}

/**
 * A sheet size ("711 x 800", "15.75 x 28") as the job card prints it.
 *
 * Sizes are kept in mm and printed as whole mm with the inches beside them.
 * A legacy job card still holds its size in INCHES, as it was typed before
 * the change to mm: no sheet is 60 mm or less on a side, so a size whose
 * every side is 60 or under is read as inches and printed exactly as it was
 * entered (15.75, not 15), with the mm beside it.
 */
export function sheetDimsForCard(exact: string): { display: string; suffix: string } {
  const text = (exact ?? '').trim();
  if (!text) return { display: '', suffix: '' };
  const parts = text.split(/\s*[xX×]\s*/).map((p) => p.trim());
  const nums = parts.map((p) => parseFloat(p));
  const numeric = nums.every((n) => Number.isFinite(n) && n > 0);
  if (numeric && nums.every((n) => n <= 60)) {
    const mm = nums.map((n) => Math.round(n * 25.4));
    return { display: `${nums.map((n) => String(Math.round(n * 1000) / 1000)).join(' x ')} in`, suffix: ` (${mm.join(' x ')} mm)` };
  }
  const inches = nums.filter((n) => Number.isFinite(n)).map((n) => String(Math.round((n / 25.4) * 100) / 100));
  return {
    display: text.replace(/(\d+)\.\d+/g, '$1'),
    suffix: inches.length === nums.length && inches.length ? ` (${inches.join(' x ')} in)` : '',
  };
}
